import { Component, type OnInit, type AfterViewInit, ViewEncapsulation, inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter, take } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { injectRumService } from './shared/services/rum/rum.service';
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { LoadingQueueService } from './core/services/loading-queue.service';

@Component({
  standalone: true,
  imports: [RouterModule, CommonModule, LoadingSpinnerComponent],
  selector: 'dpqa-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
  encapsulation: ViewEncapsulation.Emulated,
})
export class AppComponent implements OnInit, AfterViewInit {
  private router = inject(Router);
  private translateService = inject(TranslateService);
  private rumService = injectRumService();
  protected loadingQueueService = inject(LoadingQueueService);
  protected document = inject(DOCUMENT);

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = new URL(event.url, location.origin);
        const uuid = new RegExp(/[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i);
        this.rumService.awsRum()?.recordPageView(url.pathname.replace(uuid, ':id'));
      }
    });

    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
  }

  ngAfterViewInit(): void {
    this.loadingQueueService.initialLoading$.pipe(
      filter((loading) => !loading),
      take(1),
    ).subscribe(() => {
      const el = this.document.getElementById('dpqa-initial-preloader');
      el?.style.setProperty('display', 'none');
    });
  }
}
